import { render, staticRenderFns } from "./CustomerModalSimple.vue?vue&type=template&id=31214e92&scoped=true"
import script from "./CustomerModalSimple.vue?vue&type=script&lang=js"
export * from "./CustomerModalSimple.vue?vue&type=script&lang=js"
import style0 from "./CustomerModalSimple.vue?vue&type=style&index=0&id=31214e92&prod&lang=css"
import style1 from "./CustomerModalSimple.vue?vue&type=style&index=1&id=31214e92&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31214e92",
  null
  
)

export default component.exports